import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setDowntimeOperations = (state, { downtimeOperationsData }) => {
  if (!downtimeOperationsData) return state;
  return state.merge({ downtimeOperationsData });
};

const setDowntimeOperationsLoaderStatus = (state, { downtimeOperationsLoader }) => {
  return state.merge({ downtimeOperationsLoader });
};

const setTimeRangeDowntimeOperation = (state, { downtimeRangeStatus }) => {
  return state.merge({ downtimeRangeStatus });
};

const setDowntimeFilter = (state, { viewDowntime }) => {
  return state.merge({ viewDowntime });
};

const setDowntimeAddFilter = (state, { addDowntime }) => {
  return state.merge({ addDowntime });
};

const setBulkDowntime = (state, { bulkDowntimeReason }) => {
  return state.merge({ bulkDowntimeReason });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_DOWNTIME_OPERATIONS,
    actionFunction: setDowntimeOperations,
  },
  {
    actionType: ActionTypes.SET_DOWNTIME_OPERATIONS_LOADER_STATUS,
    actionFunction: setDowntimeOperationsLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_TIME_RANGE_DOWNTIME_OPERATION,
    actionFunction: setTimeRangeDowntimeOperation,
  },
  {
    actionType: ActionTypes.SET_BULK_DOWNTIME_REASON,
    actionFunction: setBulkDowntime,
  },
  {
    actionType: ActionTypes.SET_DOWNTIME_FILTER,
    actionFunction: setDowntimeFilter,
  },
  {
    actionType: ActionTypes.ADD_DOWNTIME_FILTER,
    actionFunction: setDowntimeAddFilter,
  },
];
